/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
/* eslint-disable no-console */
// console.log("Hello World! (from create-block-bloque-variable-estudi block)");
var $tabsActivats;
document.addEventListener("DOMContentLoaded", function(event) {
    activarTabs();
    activarFoldables();
});

function activarTabs(){
    // if($tabsActivats == null){
    //     $tabsActivats = 'running';
    // }else{
    //     return;
    // }

    $tabs = document.querySelectorAll('.bloque_variable-estudi .tabs');
    // document.tabs = document.querySelectorAll('.bloque_variable-estudi .tabs');
    for (let i = 0; i < $tabs.length; i++) {
        const elementTabs = $tabs[i];

        // $tabList = elementTabs.querySelectorAll('.tab');
        $tabList = elementTabs.querySelectorAll('.tab>.title');

        if($tabList.length > 0){
            for (let $j = 0; $j < $tabList.length; $j++) {
                const tab = $tabList[$j];

                tab.addEventListener('click', function(){
                    var activeTab = this.parentElement.parentElement.querySelector('.tab.active');

                    if(activeTab){
                        activeTab.classList.remove('active');
                    }

                    this.parentElement.classList.add('active');
                    let $children;
                    let $newChildActive;
                    if(this.parentElement.classList.contains('has-children')){
                        $children = this.parentElement.querySelector('.children-tabs');
                        $childActive = $children.querySelector('.active');
                        if($childActive){
                            $childActive.classList.remove('active');
                        }
                        $newChildActive = $children.querySelector('.child-tab');
                        $newChildActive.classList.add('active');
                    }

                    activeTab = this.parentElement.parentElement.parentElement.querySelector('.tab_info.active');

                    if(activeTab){
                        activeTab.classList.remove('active');
                    }
                    $id = this.parentElement.id;
                    if($children){
                        $id = $newChildActive.id;
                    }

                    $newTab = this.parentElement.parentElement.parentElement.querySelector('.tab_info.' + $id);
                    if($newTab){
                        $newTab.classList.add('active');

                        // if($newTab.classList.contains('has-children')){
                        //     console.log('contains');
                        //     $activeInfo = $newTab.querySelector('.children .child-tab.active');
                        //     if($activeInfo){
                        //         $activeInfo.classList.remove('active');
                        //     }
                            
                        //     $newTab.querySelector('.children .child-tab').classList.add('active'); // activem el primer que trobi
                        // }
                    }
                })
                
            }
        }

        /** children */
        $tabList = elementTabs.querySelectorAll('.tab.has-children .children-tabs .child-tab');
        if($tabList.length>0){
            for (let $j = 0; $j < $tabList.length; $j++) {
                const $tab = $tabList[$j];
                $tab.addEventListener('click', function(){
                    $parentTab = this.closest('.tab');

                    $parentTabs = this.closest('.tabs');


                    $actives = $parentTabs.querySelectorAll('.active');
                    if($actives.length>0){
                        for (let index = 0; index < $actives.length; index++) {
                            const $active = $actives[index];
                            $active.classList.remove('active');
                        }
                    }
                    $parentTab.classList.add('active');
                    this.classList.add('active');

                    $blockInfo = this.closest('.info-section').querySelector('.block-info');
                    $actives = $blockInfo.querySelectorAll('.active');
                    if($actives.length>0){
                        for (let index = 0; index < $actives.length; index++) {
                            const $active = $actives[index];
                            $active.classList.remove('active');
                        }
                    }
                    $blockInfo.querySelector('.tab_info.'+ this.id).classList.add('active');
                    
                });
                
            }
        }
        


        
    }
    // console.log('activartabs');
    $tabsActivats = 'activats';
}


function activarFoldables(){

    // $controls = document.querySelectorAll('.section.foldable .open-close .close, .section.foldable .open-close .open');
    $controls = document.querySelectorAll('.section.foldable .title-section');
    if($controls.length>0){
        for (let i = 0; i < $controls.length; i++) {
            const control = $controls[i];
            control.addEventListener('click', function(){
                // console.log(this.parentElement.parentElement);            
                this.closest('.section.foldable').classList.toggle('open');
            })
        }
    }

    // $controls = document.querySelectorAll('.section.foldable .docente .nombre ');
    // if($controls.length>0){
    //     for (let i = 0; i < $controls.length; i++) {
    //         const control = $controls[i];
    //         control.addEventListener('click', function(){
    //             // this.closest('.section.foldable').classList.toggle('open');
    //             this.closest('.docente').classList.toggle('open');
    //         })
    //     }
    // }
}

/* eslint-enable no-console */
